import { IMasterProduct, IOptionVariant } from '@crema/models/masterProduct';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: IMasterProduct = {
  id: '',
  code: '',
  localizedNames: [],
  categoryId: 0,
  subCategoryId: 0,
  productType: '',
  productSizeType: '',
  productOptions: [],
  productOptionInfo: '',
  optionVariants: [],
};

export const masterProductSlice = createSlice({
  name: '[MASTER_PRODUCT]',
  initialState,
  reducers: {
    setMasterProduct: (state, action: PayloadAction<IMasterProduct>) => {
      const {
        categoryId,
        code,
        id,
        localizedNames,
        optionVariants,
        productOptionInfo,
        productOptions,
        productSizeType,
        productType,
        subCategoryId,
      } = action.payload;

      state.id = id;
      state.code = code;
      state.localizedNames = localizedNames;
      state.categoryId = categoryId;
      state.subCategoryId = subCategoryId;
      state.productType = productType;
      state.productSizeType = productSizeType;
      state.productOptions = productOptions;
      state.productOptionInfo = productOptionInfo;
      state.optionVariants = optionVariants;
    },
    setOptionVariants: (state, action: PayloadAction<Array<IOptionVariant>>) => {
      state.optionVariants = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMasterProduct, setOptionVariants } = masterProductSlice.actions;

export default masterProductSlice.reducer;
